import Image from 'next/image';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import laptop from '../../public/keto/laptop.png';
import styles from './keto-admin.module.css';
import KetoContainerFluid from './keto-container-fluid';
import KetoPaper from './keto-paper';
import KetoTypography, { KetoTypographyVariant } from './keto-typography';

export default function KetoAdmin() {
  return (
    <section className={styles.admin}>
      <KetoContainerFluid>
        <div className={styles.admin__wrapper}>
          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInLeft"
            className={styles.admin__laptop}
          >
            <Image alt="Keto kitchen admin panel" src={laptop} />
          </AnimationOnScroll>
          <AnimationOnScroll
            offset={400}
            animateOnce
            duration={1.2}
            animateIn="animate__fadeInRight"
            className={styles.admin__content}
          >
            <KetoTypography
              variant={KetoTypographyVariant.HEADLINE_1}
              tag="h1"
              className={styles.admin__title}
            >
              Admin
            </KetoTypography>
            <div className={styles.admin__block}>
              <KetoPaper>
                <KetoTypography
                  className={styles.advantage_text}
                  variant={KetoTypographyVariant.BODY_2}
                  tag="p"
                >
                  MAVINX created admin panel tool to fill the app with the
                  content - recipes, products, tips of the day. It also provides
                  the flow to manage users and subscriptions.
                </KetoTypography>
              </KetoPaper>
            </div>
          </AnimationOnScroll>
        </div>
      </KetoContainerFluid>
    </section>
  );
}
